import * as React from "react";
import { isMarketType, getDictPhrase, prepareSelections } from "../../../../../../helpers";
import { BetBtnAmerican } from "../../../../components";
export var renderMiniBetButtonsAmerican = function (cardProps, market, componentPrefix) {
    var selections = prepareSelections(market, cardProps.event.isTeamSwap);
    return (React.createElement("div", { key: componentPrefix + "__" + market.id, className: "rj-ev-list__" + componentPrefix + "__section rj-ev-list__" + componentPrefix + "__section--" + market.template, "data-uat": "div-ev-list-" + componentPrefix + "-section" }, selections && selections.map(function (s, index) {
        var betslipModifier = s.isSelectionInBetslip ? "rj-ev-list__bet-btn--chosen" : "";
        var name = getSelectionName(market, s, cardProps.isDesktop, cardProps.dict);
        return (React.createElement(BetBtnAmerican, { key: componentPrefix + "__bet-btn__" + (market.id || "m") + "-" + (s && s.id || "s") + "-" + index, isDisabled: s.isDisabled, classNames: "" + betslipModifier, handler: function () { return cardProps.handlers.betButton(market, s); }, text: name, point: s.pointsText, odd: s.odds, trueOdds: s.trueOdds, hideLowOdds: cardProps.hideLowOdds }));
    })));
};
var getSelectionName = function (market, selection, isDesktop, dict) {
    if (!selection.outcomeType) {
        return "";
    }
    if (isMarketType(market.marketType.id, "ML") && !isDesktop) {
        return "";
    }
    if (isMarketType(market.marketType.id, "OU")) {
        return getDictPhrase(dict, "AmericanBtn" + selection.outcomeType);
    }
    return "";
};
//# sourceMappingURL=renderMiniBetButtonsAmerican.js.map